<button mat-button type="button" [matMenuTriggerFor]="facilityMenu">
  <span class="layout-row place-center-center gap-sm">
    <mat-icon>business</mat-icon>
    <span>{{ activeFacility()?.id }}</span>
  </span>
</button>

<mat-menu #facilityMenu="matMenu">
  @for (facility of availableFacilitiesSorted(); track facility.id) {
    <button mat-menu-item type="button" (click)="setActiveFacility(facility)">
      <mat-icon>business</mat-icon>
      <span [class.bold]="activeFacility()?.id === facility.id">
        {{ facility.name }}
      </span>
    </button>
  }
</mat-menu>
